export const isBrbEnabled = (): boolean => {
  return process.env.REACT_APP_ENABLE_BRB === "true";
};
